// extracted by mini-css-extract-plugin
export var container = "WhatNext-module--container--YNoKd";
export var container__list = "WhatNext-module--container__list--VdGgj";
export var container__title = "WhatNext-module--container__title--ZUQGd";